import ActionRequiredGrid from './ActionRequiredGrid';
import ActionRequiredTools from './ActionRequiredTools';

const ActionRequiredInvoice = () => (
  <div className="mt-2" style={{ height: '58%' }}>
    <ActionRequiredTools />
    <ActionRequiredGrid />
  </div>
);

export default ActionRequiredInvoice;
